/**
 * Shared PSR (Priority Services Register) helpers.
 *
 * The vulnerable-customer rule lives here so it stays identical across the
 * backend job-list query and any other consumer (WRK-5510).
 */
import type { Psr } from './work-orders/workOrderImport.contract';

/** Core relays XIP as the string "true" or "false" (work_order psr block, xip: z.string()). */
function isXipSet(xip: string | null | undefined): boolean {
  return typeof xip === 'string' && xip.trim().toLowerCase() === 'true';
}

/**
 * A job is flagged as serving a vulnerable customer when the PSR block reports
 * `fieldIdentified`, `iid` or `xip` (the string "true"). Any other shape (null,
 * missing flags) is not vulnerable.
 */
export function isVulnerablePsr(psr: Psr | null | undefined): boolean {
  if (!psr) return false;
  return psr.fieldIdentified === true || psr.iid === true || isXipSet(psr.xip);
}
